import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "autonomousManagement",
    iconColor: "white",
    text: "Reducing manual \nintervention",
    listItemCustomStyle: { width: "220px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "robotAndGear",
    iconColor: "white",
    text: "Minimizing \nhuman error",
    listItemCustomStyle: { width: "168px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphArrowDownUpDown",
    iconColor: "white",
    text: "Reduced \ntruck rolls",
    listItemCustomStyle: { width: "141px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "arrowsUp",
    iconColor: "white",
    text: "Increased speed \nand efficiency",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_INLCM_3 = {
  title: "Automated Build Artefacts",
  titleNumber: "3.",
  text: "Precision meets scale. Discover automation that delivers reliable, consistent network \nbuild and provisioning.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Next Lifecycle Stage",
    onClick: () => setCurrentPage("ENG_305"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_303"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_04.jpg",
};
